import { computed, defineComponent, ref } from 'vue';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { ProvinceTaskGetter } from '@/store/provinceTask/provinceTask.module';
import { ProvinceTask } from '@/store/provinceTask/provinceTask.model';
import { AccountGetter } from '@/store/account/account.module';
import { Role } from '@/store/role/role.model';
import ProvinceTaskFormComponent from '@/components/provinceTaskTable/provinceTaskForm/ProvinceTaskForm.vue';
import ProvinceTaskAttachmentOffcanvasComponent from '@/components/provinceTaskDetail/provinceTaskAttachmentOffcanvas/ProvinceTaskAttachmentOffcanvas.vue';
import ProvinceTaskAttachmentModalComponent from '@/components/provinceTaskDetail/provinceTaskAttachmentModal/ProvinceTaskAttachmentModal.vue';
import ProvinceTaskAttachmentFormComponent from '@/components/provinceTaskDetail/provinceTaskAttachmentForm/ProvinceTaskAttachmentForm.vue';
import ProvinceTaskImageModalComponent from '@/components/provinceTaskDetail/provinceTaskImageModal/ProvinceTaskImageModal.vue';

export default defineComponent({
  name: 'ProvinceTaskDetailComponent',
  components: {
    ProvinceTaskFormComponent,
    ProvinceTaskAttachmentOffcanvasComponent,
    ProvinceTaskAttachmentModalComponent,
    ProvinceTaskAttachmentFormComponent,
    ProvinceTaskImageModalComponent,
  },
  props: {
    provinceTaskId: {
      type: Number
    }
  },
  setup: (props) => {
    const dateFormat = useDateFormat();
    const store = useStore();
    const provinceTask = computed<ProvinceTask | undefined>(() => store.getters[ProvinceTaskGetter.BY_ID](props.provinceTaskId));
    const isLoading = computed(() => store.getters[ProvinceTaskGetter.STATUS] === 'init' ||  store.getters[ProvinceTaskGetter.STATUS] === 'loading');
    const role = computed<Role | undefined>(() => store.getters[AccountGetter.SINGLE_ROLE]);
    const isOrs = computed(() => role.value?.name === 'เจ้าหน้าที่ ส.กกภ.');
    const isProvince = computed(() => role.value?.name === 'เจ้าหน้าที่ประจำจังหวัด');
    const provinceTaskForm = ref<InstanceType<typeof ProvinceTaskFormComponent>>();
    const provinceTaskAttachmentOffcanvas = ref<InstanceType<typeof ProvinceTaskAttachmentOffcanvasComponent>>();
    const provinceTaskAttachmentModel = ref<InstanceType<typeof ProvinceTaskAttachmentModalComponent>>();
    const provinceTaskAttachmentForm = ref<InstanceType<typeof ProvinceTaskAttachmentFormComponent>>();
    const provinceTaskImageModal = ref<InstanceType<typeof ProvinceTaskImageModalComponent>>();

    const editClick = () => {
      provinceTaskForm.value?.show();
    };

    const attachmentClick = () => {
      provinceTaskAttachmentModel.value?.show();
    };

    const uploadClick = () => {
      Promise.resolve(provinceTaskAttachmentModel.value?.hide())
        .then(() => provinceTaskAttachmentForm.value?.show());
    };

    const uploadClose = () => {
      Promise.resolve(provinceTaskAttachmentForm.value?.hide())
        .then(() => provinceTaskAttachmentModel.value?.show());
    };

    const imageClick = () => {
      provinceTaskImageModal.value?.show();
    };

    const showAttachment = () => {
      provinceTaskAttachmentOffcanvas.value?.show();
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'long');

    return {
      provinceTask,
      isOrs,
      isProvince,
      isLoading,
      provinceTaskForm,
      provinceTaskAttachmentOffcanvas,
      provinceTaskAttachmentModel,
      provinceTaskAttachmentForm,
      provinceTaskImageModal,
      editClick,
      attachmentClick,
      uploadClick,
      uploadClose,
      imageClick,
      showAttachment,
      thaiDate,
    };
  }
});
